// extracted by css-extract-rspack-plugin
export default {"reset":"DisclosureTrigger-module__reset__yrAHo"};